import { render, staticRenderFns } from "./Alerts-list.vue?vue&type=template&id=83c216e4&scoped=true"
import script from "./Alerts-list.vue?vue&type=script&lang=js"
export * from "./Alerts-list.vue?vue&type=script&lang=js"
import style0 from "./Alerts-list.vue?vue&type=style&index=0&id=83c216e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c216e4",
  null
  
)

export default component.exports